export const courses = [
    {   _id: 1,
        title: "Computer System Servicing NCII",
        description: "covers basic and common competencies such as installing, maintaining, configuring, and diagnosing computer systems and networks.",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
        alt: "HTML5",
    },
    {
        _id: 2,
        title: "Next.js (Official Learn)",
        description: "Interactive tutorial by Vercel covering Next.js fundamentals — routing, data fetching, rendering strategies, and deployment. Ideal for building production-ready React apps using server-side rendering and static generation.",
        image: "https://cdn.jsdelivr.net/npm/simple-icons@v7/icons/nextdotjs.svg",
        alt: "Next.js",
        link: "https://nextjs.org/learn"
    },

]